import {
    FETCH_CHATS_SUCCESS,
    FETCH_CHATS_FAILURE,
    CREATE_CHAT_SUCCESS,
    CREATE_CHAT_FAILURE,
    DELETE_CHAT_SUCCESS,
    DELETE_CHAT_FAILURE,
    RENAME_CHAT_SUCCESS,
    RENAME_CHAT_FAILURE,
    CLEAR_CHAT_ERROR,
  } from './actionTypes.js';
  
  import {
    fetchChats as fetchChatsApi,
    createChat as createChatApi,
    deleteChat as deleteChatApi,
    renameChat as renameChatApi,
  } from '../../services/api.js';

  export const fetchChats = (user_id) => async (dispatch) => {
    try {
      const response = await fetchChatsApi(user_id);
      response.data.sort((a, b) => new Date(a.created_at) - new Date(b.created_at)).reverse();

      dispatch({
        type: FETCH_CHATS_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_CHATS_FAILURE,
        payload: error.message,
      });
    }
  }
  
  export const createChat = (user_id, chat_name) => async (dispatch) => {
    try {
      const response = await createChatApi(user_id, chat_name);
      dispatch({
        type: CREATE_CHAT_SUCCESS,
        payload: response.data,
      });
      return response.data.chat_id;
    } catch (error) {
      dispatch({
        type: CREATE_CHAT_FAILURE,
        payload: error.message,
      });
      return null;
    }
  };
  
  export const deleteChat = (user_id, chat_id) => async (dispatch) => {
    try {
      const response = await deleteChatApi(user_id, chat_id);
      dispatch({
        type: DELETE_CHAT_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: DELETE_CHAT_FAILURE,
        payload: error.message,
      });
    }
  };
  
  export const renameChat = (user_id, chat_id, chat_name) => async (dispatch) => {
    try {
      const response = await renameChatApi(user_id, chat_id, chat_name);
      dispatch({
        type: RENAME_CHAT_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: RENAME_CHAT_FAILURE,
        payload: error.message,
      });
    }
  };


  export const clearChatError = () => ({
    type: CLEAR_CHAT_ERROR,
  });
  